<template>
  <div class="app-home">
    <div class="app-home-nav"></div>
    <div class="app-home-body">
      <div class="body_nav">学习视频</div>
      <div class="body_label">
        <div class="item" :class="{ 'item--active': labelChecked == '全部视频' }" @click="banleAllLable()">
          全部视频
        </div>
        <div class="item" :class="{ 'item--active': labelChecked == item.value }" v-for="(item, index) in labelOptions"
          :key="index" @click="banleLable(item)">
          {{ item.value }}
        </div>
      </div>
      <div class="body_main">
        <div class="item" v-for="(h, index) in list" :key="index" @click="bandleVideo(h)">
          <div class="item_image" :style="`background-image:url(${h.video_img_url})`">
            <div class="title">
              <p>{{ h.video_title }}</p>
            </div>
            <div class="vTime">{{ h.video_time_str }}</div>
          </div>
          <div class="item_title">
            <!-- <span style="font-weight: bold">授课单位：</span> -->
            <span v-html="h.video_description"></span>
          </div>
          <div class="item_title2">
            <span>{{ h.video_type }}</span>
            <span>已观看：{{ h.done_process }}</span>
          </div>
        </div>
      </div>
      <div class="more" v-if="total != list.length">
        <div @click="bandleMore">加载更多</div>
      </div>
      <div class="unMore" v-else>
        <div>没有更多了</div>
      </div>
    </div>
  </div>
</template>

<script>
import { listVideoProcessPage, getSettings } from "@/api/home";

export default {
  data() {
    return {
      labelOptions: [
      ],
      labelChecked: "全部视频",
      list: [],
      total: 0,
      loading: false,
      unMore: false,
      form: {
        page: 1,
        limit: 12,
        type: "",
        title: "",
      },
    };
  },
  created() {
    // 加载视频类型数据
    this.getSettings();
    // 获取视频列表
    this.getList();
  },
  methods: {
    //获取视频列表数据
    getList() {
      const loading = this.$loading({
        target: document.querySelector(".body_main"),
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      listVideoProcessPage(this.form).then((res) => {
        if (res.code == 0) {
          loading.close();
          this.total = res.data.totalCount;
          if (res.data.list.length != 0) {
            this.list = this.list.concat(res.data.list);
          } else {
            if (this.form.page == 1) {
              this.list = [];
            } else {
              this.form.page -= 1;
              // this.unMore = true;
            }
          }
        }
      });
    },
    // 加载视频类型数据
    getSettings() {
      getSettings({ cd: "video_type" }).then((res) => {
        if (res.code == 0) {
          this.labelOptions = res.data;
        }
      });
    },
    //加载全部类型的视频
    banleAllLable() {
      this.form.page = 1;
      this.list = [];
      this.labelChecked = "全部视频"
      this.form.type = ""
      this.getList();
    },
    //切换类型
    banleLable(item) {
      this.form.page = 1;
      this.list = [];
      // this.unMore = false;
      this.labelChecked = item.value;
      this.form.type = item.value == "全部视频" ? "" : item.value;
      this.getList();
    },
    //加载更多
    bandleMore() {
      this.form.page += 1;
      this.loading = true;
      this.getList();
    },
    bandleVideo(data) {
      this.$router.push(`/video/${data.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-home {
  background-color: #f5f5f5;
  padding-bottom: 80px;
}

.app-home-nav {
  width: 100%;
  height: 378px;
  background: url("~@/assets/images/headbg.jpg") no-repeat center;
}

.app-home-body {
  width: 1100px;
  margin: 0 auto;
  min-height: 300px;

  .body_nav {
    margin-top: 20px;
    position: relative;
    padding-left: 20px;
    color: #333333;
    font-size: 18px;

    &::before {
      content: "";
      width: 10px;
      height: 25px;
      background: #1d2088;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .body_label {
    margin-top: 10px;
    width: 100%;
    background-color: #fff;
    margin-bottom: 15px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 10px 10px;
    flex-wrap: wrap;

    .item {
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      border-radius: 2px;
      padding: 5px 10px;
      border: 1px solid #dbe2e7;
      color: #788188;
      margin: 5px 0 5px 10px;

      &--active {
        color: #fff;
        background-color: #545ca6;
        border-color: #545ca6;
      }
    }
  }

  .body_main {
    display: flex;
    flex-wrap: wrap;
    min-height: 400px;

    .item:nth-child(3n + 2) {
      margin: 0 22px;
    }

    .item {
      width: 352px;
      height: 300px;
      float: left;
      background-color: white;
      cursor: pointer;
      overflow: hidden;
      border-radius: 5px;
      margin-bottom: 20px;

      .item_image {
        width: auto;
        height: 200px;
        background: center no-repeat;
        background-size: 350px auto;
        border: #ddd solid 1px;
        position: relative;

        .title {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 40px;
          background-color: rgba(100, 100, 100, 0.6);
          overflow: hidden;
          color: white;

          p {
            font-size: 18px;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 7.5px 10px;
          }
        }

        .vTime {
          position: absolute;
          top: 0;
          right: 0;
          background-color: rgba(100, 100, 100, 0.6);
          color: #fff;
          padding: 6px 10px;
        }
      }

      .item_title {
        font-size: 16px;
        padding: 0 10px;
        overflow: hidden;
        height: 40px;
      }

      .item_title2 {
        font-size: 16px;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        font-weight: bold;
      }
    }
  }
}

.unMore {
  text-align: center;

  div {
    display: inline-block;
    font-size: 16px;
  }
}

.more {
  text-align: center;

  &:hover {
    color: #409eff;
  }

  div {
    display: inline-block;
    font-size: 16px;
    cursor: pointer;
  }

  .el-icon-loading {
    font-size: 22px;
    color: #409eff;
  }
}

.el-pagination {
  text-align: right;

  ::v-deep .el-pager .number {
    background-color: #fff;
  }
}
</style>
